import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import type { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { IMainState } from 'store/states'

import * as fromProfilesActions from 'store/actions/lms-profiles.action'
import { usePermissionsList } from 'hooks/usePermissionsList'

const useUserColumnsFilters = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const lmsProfileList = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles.allProfilesList
  )

  useEffect(() => {
    dispatch({ type: fromProfilesActions.LMS_ALL_PROFILES_LIST })
  }, [dispatch])

  const permissionsList = usePermissionsList()

  const prefixUserList = 'configuration.users.list'
  const translateHeaderPrefix = `${prefixUserList}.headers`
  const translateFiltersPrefix = `${prefixUserList}.filters`

  const filtersColumns: IFilterOption[] = useMemo(
    () => [
      {
        label: t(`${translateHeaderPrefix}.name`),
        value: 'full_name',
        type: 'string',
      },
      {
        label: t(`${translateHeaderPrefix}.position`),
        value: 'position',
        type: 'string',
      },
      {
        label: t(`${translateHeaderPrefix}.identifier`),
        value: 'identifier',
        type: 'string',
      },
      {
        label: t(`${translateHeaderPrefix}.area`),
        value: 'area_name',
        type: 'string',
      },
      {
        label: t(`${translateHeaderPrefix}.lmsProfile`),
        value: 'lms_profiles_id',
        type: 'tagsList',
        list: lmsProfileList.map(({ id, name, color }) => ({
          value: id,
          label: name,
          color,
        })),
      },
      {
        label: t(`${translateFiltersPrefix}.role`),
        value: 'role_id',
        type: 'list',
        list: permissionsList,
      },
    ],
    [
      lmsProfileList,
      permissionsList,
      t,
      translateFiltersPrefix,
      translateHeaderPrefix,
    ]
  )

  return {
    filtersColumns,
  }
}

export default useUserColumnsFilters
